<template>
  <div>
    <div class="title1">
      {{ $t("info_card.school_location") }}
    </div>
    <ThaiOrForeignCountry
      v-model="EducationBGUndergrad_schoolLocation"
      :shown="true"
    />
    <v-row v-if="this.EducationBGUndergrad_schoolLocation === 'foreignCountry'">
      <v-col cols="12" sm="4">
        <CountryCard v-model="EducationBGUndergrad_countryIdOfSchool" />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGUndergrad_schoolName"
          v-bind:label="$t('info_card.school_name')"
          v-bind:placeholder="$t('info_card.school_name')"
          v-bind:hint="$t('info_card.school_name')"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="this.EducationBGUndergrad_schoolLocation === 'inThai'">
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGUndergrad_provinceIdOfSchool"
          v-bind:label="$t('info_card.province')"
          v-bind:item-text="(item) => objectTranslator(item, 'PROVINCE_NAME')"
          v-bind:items="provinces"
          v-bind:item-value="(item) => item.PROVINCE_ID"
          v-bind:rules="requiredRules"
          outlined
          dense
          @change="(e) => update_province(e)"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4">
        <!-- ต้องเรียกชื่อ รร.จาก DB registrar -->
        <v-autocomplete
          v-model="EducationBGUndergrad_schoolId"
          v-bind:label="$t('info_card.school_name')"
          v-bind:rules="requiredRules"
          v-bind:item-text="(item) => item.SCHOOL_NAME"
          v-bind:items="schools"
          v-bind:item-value="(item) => item.SCHOOL_CODE"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4"> {{ $t("info_card.add_school") }}</v-col>
    </v-row>
    <v-row v-if="this.EducationBGUndergrad_schoolLocation === 'other'">
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGUndergrad_schoolName"
          v-bind:label="$t('info_card.school_name')"
          v-bind:placeholder="$t('info_card.school_name')"
          v-bind:hint="$t('info_card.school_name')"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGUndergrad_schoolTypeId"
          v-bind:label="$t('info_card.school_type')"
          v-bind:item-text="
            (item) => objectTranslator(item, 'SCHOOL_TYPE_NAME')
          "
          v-bind:items="schoolTypes"
          v-bind:item-value="(item) => item.SCHOOL_TYPE_ID"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGUndergrad_educationTypeId"
          v-bind:label="$t('info_card.education_type')"
          v-bind:item-text="
            (item) => objectTranslator(item, 'EDUCATION_TYPE_NAME')
          "
          v-bind:items="educationTypes"
          v-bind:item-value="(item) => item.EDUCATION_TYPE_ID"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        v-if="EducationBGUndergrad_educationTypeId == '90'"
      >
        <v-text-field
          v-model="EducationBGUndergrad_educationOther"
          v-bind:label="$t('info_card.education_other')"
          v-bind:placeholder="$t('info_card.education_other_hint')"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGUndergrad_studyStatusId"
          v-bind:label="$t('info_card.study_status')"
          v-bind:item-text="
            (item) => objectTranslator(item, 'SCHOOL_STUDY_STATUS_NAME')
          "
          v-bind:items="schoolStudyStatuss"
          v-bind:item-value="(item) => item.SCHOOL_STUDY_STATUS_ID"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGUndergrad_studyTypeId"
          v-bind:label="$t('info_card.study_type')"
          v-bind:item-text="
            (item) => objectTranslator(item, 'SCHOOL_STUDY_TYPE_NAME')
          "
          v-bind:items="schoolStudyTypes"
          v-bind:item-value="(item) => item.SCHOOL_STUDY_TYPE_ID"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGUndergrad_termOfGpa"
          v-bind:label="$t('info_card.number_of_GPA_term')"
          v-bind:item-text="(item) => item"
          v-bind:items="terms"
          v-bind:item-value="(item) => item"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4">
        <GpaCard
          v-model="EducationBGUndergrad_GPA"
          v-bind:textLabel="$t('info_card.GPA')"
          v-bind:textPlaceholder="$t('info_card.GPA')"
          v-bind:textHint="$t('info_card.GPA_hint')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ThaiOrForeignCountry from "./ThaiOrForeignCountry";
import CountryCard from "./Country";
import GpaCard from "./GPA";
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";
import RefProvider from "@/services/ref.provider";

const refService = new RefProvider();

export default {
  name: "EducationBackgroundUndergradInfoCard",
  props: [
    "value_schoolLocation",
    "value_countryIdOfSchool",
    "value_schoolName",
    "value_provinceIdOfSchool",
    "value_schoolId",
    "value_schoolTypeId",
    "value_educationTypeId",
    "value_educationOther",
    "value_studyStatusId",
    "value_studyTypeId",
    "value_termOfGpa",
    "value_GPA",
  ],
  data: function() {
    return {
      terms: ["2", "3", "4", "5", "6"],

      provinces: [],
      schools: [],

      requiredRules: [validator.required],
    };
  },
  components: {
    ThaiOrForeignCountry,
    CountryCard,
    GpaCard,
  },

  methods: {
    objectTranslator,

    async update_province(province_id) {
      const dataSchools = await refService.getRegistrarSchoolByProvince(
        province_id
      );
      this.schools = dataSchools;
      this.EducationBGUndergrad_schoolId = null;
    },
    async fetch_data() {
      const data1 = await refService.getProvince();
      this.provinces = data1;

      if (this.EducationBGUndergrad_provinceIdOfSchool) {
        const dataSchools = await refService.getRegistrarSchoolByProvince(
          this.EducationBGUndergrad_provinceIdOfSchool
        );
        this.schools = dataSchools;
      }
    },
  },
  computed: {
    // store
    // provinces: function() {
    //   return this.$store.state.ref.provinces;
    // },
    schoolTypes: function() {
      return this.$store.state.ref.schoolTypes;
    },
    educationTypes: function() {
      return this.$store.state.ref.educationTypes;
    },
    schoolStudyStatuss: function() {
      return this.$store.state.ref.schoolStudyStatuss;
    },
    schoolStudyTypes: function() {
      return this.$store.state.ref.schoolStudyTypes;
    },
    // get / set
    EducationBGUndergrad_schoolLocation: {
      get() {
        return this.value_schoolLocation;
      },
      set(value) {
        this.$emit("input_schoolLocation", value);
      },
    },
    EducationBGUndergrad_countryIdOfSchool: {
      get() {
        return this.value_countryIdOfSchool;
      },
      set(value) {
        this.$emit("input_countryIdOfSchool", value);
      },
    },
    EducationBGUndergrad_schoolName: {
      get() {
        return this.value_schoolName;
      },
      set(value) {
        this.$emit("input_schoolName", value);
      },
    },
    EducationBGUndergrad_provinceIdOfSchool: {
      get() {
        return this.value_provinceIdOfSchool;
      },
      set(value) {
        this.$emit("input_provinceIdOfSchool", value);
      },
    },
    EducationBGUndergrad_schoolId: {
      get() {
        return this.value_schoolId;
      },
      set(value) {
        this.$emit("input_schoolId", value);
      },
    },
    EducationBGUndergrad_schoolTypeId: {
      get() {
        return this.value_schoolTypeId;
      },
      set(value) {
        this.$emit("input_schoolTypeId", value);
      },
    },
    EducationBGUndergrad_educationTypeId: {
      get() {
        return this.value_educationTypeId;
      },
      set(value) {
        this.$emit("input_educationTypeId", value);
      },
    },
    EducationBGUndergrad_educationOther: {
      get() {
        return this.value_educationOther;
      },
      set(value) {
        this.$emit("input_educationOther", value);
      },
    },
    EducationBGUndergrad_studyStatusId: {
      get() {
        return this.value_studyStatusId;
      },
      set(value) {
        this.$emit("input_studyStatusId", value);
      },
    },
    EducationBGUndergrad_studyTypeId: {
      get() {
        return this.value_studyTypeId;
      },
      set(value) {
        this.$emit("input_studyTypeId", value);
      },
    },
    EducationBGUndergrad_termOfGpa: {
      get() {
        return this.value_termOfGpa;
      },
      set(value) {
        this.$emit("input_termOfGpa", value);
      },
    },
    EducationBGUndergrad_GPA: {
      get() {
        return this.value_GPA;
      },
      set(value) {
        this.$emit("input_GPA", value);
      },
    },
  },
  watch: {
    EducationBGUndergrad_educationTypeId(val) {
      if (val != "90") this.EducationBGUndergrad_educationOther = "";
    },
  },
  mounted: function() {
    // this.$store.dispatch("ref/getProvinces");
    this.$store.dispatch("ref/getSchoolTypes");
    this.$store.dispatch("ref/getEducationTypes");
    this.$store.dispatch("ref/getSchoolStudyStatuss");
    this.$store.dispatch("ref/getSchoolStudyTypes");

    this.fetch_data();
  },
};
</script>
<style scoped>
.title1 {
  /* color: purple; */
  /* text-decoration: underline; */
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.title2 {
  font-size: 20px;
  margin-bottom: 20px;
}
</style>
